import { DialogTitle } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'
import { c, FC } from 'lib/component-utils'
import Button from 'components/base/Button'
import { useHideModal } from 'components/app/ModalDispatcher'

type Props = {
  title: string
  onClose?: () => void
}

const ModalWithHeader: FC<Props> = ({ title, onClose, className, children }) => {
  const hideModal = useHideModal()

  return (
    <>
      <div
        className={c`sticky top-0 z-10 rounded-t-lg px-8 flex items-center bg-gray-100/90 backdrop-blur-sm backdrop-saturate-200 place-content-between ${
          title.length > 0
        } py-3 | py-1.5 ${className}`}
      >
        <DialogTitle as="h3" className="text-xl font-medium">
          {title}
        </DialogTitle>
        <Button
          theme="gray"
          onClick={() => (onClose ? onClose() : hideModal())}
          className="px-2 -mx-4 focus:!ring-0 focus:!ring-offset-0"
        >
          <XIcon className="w-5 h-5" />
        </Button>
      </div>
      {children}
    </>
  )
}

export default ModalWithHeader
